/* eslint-disable import/prefer-default-export */

import { LaunchModuleApprovalStatus } from '~generated/types'
import DoneSmall from '~icons/illustrations/done.small.svg'
import InProgressSmall from '~icons/illustrations/in_progress.small.svg'
import InReviewSmall from '~icons/illustrations/in_review.small.svg'
import NotStartedSmall from '~icons/illustrations/not_started.small.svg'

export type AssetApprovalStatusOption = {
  value: LaunchModuleApprovalStatus
  label: string
  getIcon: () => React.ReactNode | null
}

export const assetApprovalStatusOptions: AssetApprovalStatusOption[] = [
  {
    value: LaunchModuleApprovalStatus.NOT_REQUESTED,
    label: 'Not started',
    getIcon: () => <NotStartedSmall />,
  },
  {
    value: LaunchModuleApprovalStatus.APPROVING,
    label: 'Approval sent',
    getIcon: () => <InReviewSmall />,
  },
  {
    value: LaunchModuleApprovalStatus.READY_TO_REQUEST,
    label: 'Partially approved',
    getIcon: () => <InProgressSmall />,
  },
  {
    value: LaunchModuleApprovalStatus.APPROVED,
    label: 'Fully approved',
    getIcon: () => <DoneSmall />,
  },
]
